export const POST_USER = 'POST_USER';
export const LIST_USER = 'LIST_USER';
